// Copyright 2023 Sorama B.V.
import { Mass } from "units/Mass";
import { UnitValue } from "units/Unit";

export class CountryEmissions {
    public static get countries(): string[] {
        return this.list.map((x) => x.country).filter((value, index, self) => self.indexOf(value) === index);
    }

    public static getRegions(country: string): string[] {
        return this.list
            .filter((x) => x.country === country)
            .map((x) => x.gridRegion)
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    public static getFactor(country: string, region: string): UnitValue {
        if (!this.list.find((x) => x.country === country && x.gridRegion === region)) {
            return new UnitValue(0, Mass.kiloGram);
        }
        return new UnitValue(
            this.list.find((x) => x.country === country && x.gridRegion === region).factor,
            Mass.kiloGram
        );
    }

    public static list = [
        { country: "United States", gridRegion: "United States Average", factor: 0.37110612244898 },
        { country: "United States", gridRegion: "ASCC Alaska Grid", factor: 0.497791383219955 },
        { country: "United States", gridRegion: "ASCC Miscellaneous", factor: 0.242209977324263 },
        { country: "United States", gridRegion: "ERCOT All", factor: 0.37124716553288 },
        { country: "United States", gridRegion: "FRCC All", factor: 0.378720634920635 },
        { country: "United States", gridRegion: "HICC Miscellaneous", factor: 0.518470294784581 },
        { country: "United States", gridRegion: "HICC Oahu", factor: 0.749638095238095 },
        { country: "United States", gridRegion: "MRO East", factor: 0.692233106575964 },
        { country: "United States", gridRegion: "MRO West", factor: 0.444234013605442 },
        { country: "United States", gridRegion: "NPCC Long Island", factor: 0.545998639455782 },
        { country: "United States", gridRegion: "NPCC New England", factor: 0.239563718820862 },
        { country: "United States", gridRegion: "NPCC NYC/Westchester", factor: 0.28780589569161 },
        { country: "United States", gridRegion: "NPCC Upstate NY", factor: 0.105901133786848 },
        { country: "United States", gridRegion: "Puerto Rico Miscellaneous", factor: 0.726614058956916 },
        { country: "United States", gridRegion: "RFC East", factor: 0.295899319727891 },
        { country: "United States", gridRegion: "RFC Michigan", factor: 0.522928798185941 },
        { country: "United States", gridRegion: "RFC West", factor: 0.446701587301587 },
        { country: "United States", gridRegion: "SERC Midwest", factor: 0.671518820861678 },
        { country: "United States", gridRegion: "SERC Mississippi Valley", factor: 0.335763718820862 },
        { country: "United States", gridRegion: "SERC South", factor: 0.390103854875283 },
        { country: "United States", gridRegion: "SERC Tennessee Valley", factor: 0.378313832199547 },
        { country: "United States", gridRegion: "SERC Virginia/Carolina", factor: 0.282590022675737 },
        { country: "United States", gridRegion: "SPP North", factor: 0.432667573696145 },
        { country: "United States", gridRegion: "SPP South", factor: 0.422565079365079 },
        { country: "United States", gridRegion: "WECC California", factor: 0.232859410430839 },
        { country: "United States", gridRegion: "WECC Northwest", factor: 0.27209387755102 },
        { country: "United States", gridRegion: "WECC Rockies", factor: 0.519184126984127 },
        { country: "United States", gridRegion: "WECC Southwest", factor: 0.38395283446712 },
        { country: "Canada", gridRegion: "Canada Average", factor: 0.12 },
        { country: "Canada", gridRegion: "Alberta", factor: 0.62 },
        { country: "Canada", gridRegion: "British Columbia", factor: 0.0183 },
        { country: "Canada", gridRegion: "Manitoba", factor: 0.0012 },
        { country: "Canada", gridRegion: "New Brunswick", factor: 0.26 },
        { country: "Canada", gridRegion: "Newfoundland and Labrador", factor: 0.027 },
        { country: "Canada", gridRegion: "Northwest Territories", factor: 0.2 },
        { country: "Canada", gridRegion: "Nova Scotia", factor: 0.71 },
        { country: "Canada", gridRegion: "Nunavut", factor: 0.84 },
        { country: "Canada", gridRegion: "Ontario", factor: 0.03 },
        { country: "Canada", gridRegion: "Prince Edward Island", factor: 0.002 },
        { country: "Canada", gridRegion: "Quebec", factor: 0.0012 },
        { country: "Canada", gridRegion: "Saskatchewan", factor: 0.66 },
        { country: "Canada", gridRegion: "Yukon", factor: 0.1 },
        { country: "Australia", gridRegion: "Australia Average", factor: 0.78 },
        { country: "Australia", gridRegion: "New South Wales and ACT", factor: 0.84 },
        { country: "Australia", gridRegion: "Northern Territory", factor: 0.62 },
        { country: "Australia", gridRegion: "Queensland", factor: 0.81 },
        { country: "Australia", gridRegion: "SWIS in Western Australia", factor: 0.68 },
        { country: "Australia", gridRegion: "South Australia", factor: 0.43 },
        { country: "Australia", gridRegion: "Tasmania", factor: 0.15 },
        { country: "Australia", gridRegion: "Victoria", factor: 0.98 },
        { country: "Argentina", gridRegion: "Argentina Average", factor: 0.428 },
        { country: "Austria", gridRegion: "Austria Average", factor: 0.092 },
        { country: "Belgium", gridRegion: "Belgium Average", factor: 0.174 },
        { country: "Brazil", gridRegion: "Brazil Average", factor: 0.1264 },
        { country: "Bulgaria", gridRegion: "Bulgaria Average", factor: 0.427 },
        { country: "Chile", gridRegion: "Chile Average", factor: 0.4187 },
        { country: "Colombia", gridRegion: "Colombia Average", factor: 0.203 },
        { country: "Costa Rica", gridRegion: "Costa Rica Average", factor: 0.04 },
        { country: "Croatia", gridRegion: "Croatia Average", factor: 0.163 },
        { country: "Cyprus", gridRegion: "Cyprus Average", factor: 0.642 },
        { country: "Czechia", gridRegion: "Czechia Average", factor: 0.433 },
        { country: "Denmark", gridRegion: "Denmark Average", factor: 0.123 },
        { country: "Ecuador", gridRegion: "Ecuador Average", factor: 0.3834 },
        { country: "El Salvador", gridRegion: "El Salvador Average", factor: 0.6077 },
        { country: "Estonia", gridRegion: "Estonia Average", factor: 0.733 },
        { country: "European Union + UK", gridRegion: "EuropeanUnion + UK", factor: 0.25 },
        { country: "Finland", gridRegion: "Finland Average", factor: 0.084 },
        { country: "France", gridRegion: "France Average", factor: 0.056 },
        { country: "Germany", gridRegion: "Germany Average", factor: 0.344 },
        { country: "Greece", gridRegion: "Greece Average", factor: 0.606 },
        { country: "Guatemala", gridRegion: "Guatemala Average", factor: 0.3913 },
        { country: "Hungary", gridRegion: "Hungary Average", factor: 0.227 },
        { country: "India", gridRegion: "India Average", factor: 0.7082 },
        { country: "Indonesia", gridRegion: "Indonesia Average", factor: 0.7177 },
        { country: "Ireland", gridRegion: "Ireland Average", factor: 0.316 },
        { country: "Italy", gridRegion: "Italy Average", factor: 0.234 },
        { country: "Japan", gridRegion: "Japan Average", factor: 0.4658 },
        { country: "Latvia", gridRegion: "Latvia Average", factor: 0.16 },
        { country: "Lithuania", gridRegion: "Lithuania Average", factor: 0.072 },
        { country: "Luxembourg", gridRegion: "Luxembourg Average", factor: 0.073 },
        { country: "Malaysia", gridRegion: "Malaysia Average", factor: 0.57 },
        { country: "Malta", gridRegion: "Malta Average", factor: 0.357 },
        { country: "Mexico", gridRegion: "Mexico Average", factor: 0.423 },
        { country: "Netherlands", gridRegion: "Netherlands Average", factor: 0.392 },
        { country: "New Zealand", gridRegion: "New Zealand Average", factor: 0.1547 },
        { country: "People's Republic of China", gridRegion: "PRC Average", factor: 0.841 },
        { country: "Philippines", gridRegion: "Philippines Average", factor: 0.691 },
        { country: "Peru", gridRegion: "Peru Average", factor: 0.1739 },
        { country: "Portugal", gridRegion: "Portugal Average", factor: 0.255 },
        { country: "Poland", gridRegion: "Poland Average", factor: 0.744 },
        { country: "Portugal", gridRegion: "Portugal Average", factor: 0.255 },
        { country: "Romania", gridRegion: "Romania Average", factor: 0.289 },
        { country: "Saudi Arabia", gridRegion: "Saudi Arabia Average", factor: 0.5059 },
        { country: "Singapore", gridRegion: "Singapore Average", factor: 0.408 },
        { country: "Slovakia", gridRegion: "Slovakia Average", factor: 0.122 },
        { country: "Slovenia", gridRegion: "Slovenia Average", factor: 0.238 },
        { country: "South Africa", gridRegion: "South Africa Average", factor: 0.9006 },
        { country: "South Korea", gridRegion: "South Korea Average", factor: 0.4781 },
        { country: "Spain", gridRegion: "Spain Average", factor: 0.21 },
        { country: "Sweden", gridRegion: "Sweden Average", factor: 0.01 },
        { country: "Switzerland", gridRegion: "Switzerland Average", factor: 0.059 },
        { country: "Taiwan, China", gridRegion: "Taiwan Average", factor: 0.502 },
        { country: "Thailand", gridRegion: "Thailand Average", factor: 0.442 },
        { country: "Turkey", gridRegion: "Turkey Average", factor: 0.375 },
        { country: "United Arab Emirates", gridRegion: "United Arab Emirates Average", factor: 0.4041 },
        { country: "United Kingdom", gridRegion: "United Kingdom Average", factor: 0.225 },
        { country: "Vietnam", gridRegion: "Vietnam Average", factor: 0.521 },
    ];
}
